import { render, staticRenderFns } from "./AdminViewInfoCard.vue?vue&type=template&id=2b002128&"
import script from "./AdminViewInfoCard.vue?vue&type=script&lang=ts&"
export * from "./AdminViewInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports